import { AssignedTo, UserRole } from "@green0meter/api-client";

export const USER_ROLE_VALUES: Record<number, string> = {
  [UserRole.Respondent]: "respondent",
  [UserRole.Owner]: "owner",
  [UserRole.Manager]: "manager",
  [UserRole.Viewer]: "viewer",
  [UserRole.Admin]: "admin",
  [UserRole.Auditor]: "auditor",
} as const;

export const ASSIGN_TO_VALUES: Record<number, string> = {
  [AssignedTo.OnlyOwner]: "onlyOwner",
  [AssignedTo.OwnerAndManagers]: "ownerAndManagers",
  [AssignedTo.Everyone]: "everyone",
  [AssignedTo.Hidden]: "hidden",
  [AssignedTo.Mixed]: "mixed",
} as const;

export const canUserManageFiles = (
  userRole: UserRole,
  assignedTo: AssignedTo,
  userId: string,
  assignedUserIds: string[],
  createdById?: string,
): boolean => {
  // Basic rule - Owner/Manager can manage file
  if (userRole === UserRole.Owner || userRole === UserRole.Manager) return true;
  // If assignetTo is set to Mixed and userId is in assigned users then can manage file
  if (assignedTo === AssignedTo.Mixed && assignedUserIds.includes(userId))
    return true;
  // If user is file owner
  if (createdById && userId === createdById) return true;

  return false;
};
